import { throwError, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, catchError } from 'rxjs/operators';
import { AuthTokenService } from './auth-token.service';
import { ApiService } from './api.service';
import { environment } from '@env/environment';
import { StorageService } from './storage.service';
var AuthService = /** @class */ (function () {
    function AuthService(httpClient, authToken, apiService, storage) {
        this.httpClient = httpClient;
        this.authToken = authToken;
        this.apiService = apiService;
        this.storage = storage;
        this.user$ = new BehaviorSubject(null);
        this.isAdmin$ = new BehaviorSubject(null);
        this.isLoggedIn = false;
    }
    AuthService.prototype.load = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.storage.get("USER").then(function (user) {
                _this.user = user;
                resolve(user);
            }, function (error) {
                resolve(null);
            });
        });
    };
    Object.defineProperty(AuthService.prototype, "user", {
        get: function () {
            return this.user$.value;
        },
        set: function (value) {
            this.user$.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "isAdmin", {
        get: function () {
            return this.isAdmin$.value;
        },
        set: function (value) {
            this.isAdmin$.next(value);
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.login = function (username, password) {
        var _this = this;
        //console.log("KAMNOUME LOGIN TORA");
        var grant_type = "password";
        var scope = "offline_access";
        var httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };
        var body = new URLSearchParams();
        body.set('grant_type', grant_type);
        body.set('username', username);
        body.set('password', password);
        // body.set('scope', scope); 
        return this.httpClient.post(environment.LOGINURL, body.toString(), httpOptions)
            .pipe(map(function (data) {
            _this.isLoggedIn = true;
            _this.authToken.token = data.access_token;
            _this.loadUser();
            return true;
        }, catchError(this.handleError)));
    };
    AuthService.prototype.loadUser = function () {
        var _this = this;
        this.apiService.getUser().subscribe(function (data) {
            _this.user = data;
            _this.user.admin = false;
            //this.storage.set("ISADMIN", false);
            if (_this.user.roles.some(function (x) { return x === "Admin"; })) {
                _this.user.admin = true;
                //this.storage.set("ISADMIN", true);
            }
            _this.storage.set("USER", _this.user).then(function (_) {
                _this.IsAdmin();
            });
        });
    };
    AuthService.prototype.IsAdmin = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.storage.get("USER").then(function (user) {
                _this.isAdmin = user.admin;
                resolve(_this.isAdmin);
            }, function (error) {
                reject("Error in Helper.IsAdmin");
            });
        });
    };
    AuthService.prototype.logout = function () {
        var _this = this;
        this.storage.remove("USER").then(function (_) {
            _this.authToken.token = null;
            _this.isLoggedIn = false;
        });
    };
    AuthService.prototype.handleError = function (error) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        var errMsg = error.error.error_description
            ? error.error.error_description
            : error.status
                ? error.status + " - " + error.statusText
                : 'Server error';
        console.error(errMsg); // log to console instead
        return throwError(errMsg);
        //return Observable.throw(errMsg);
    };
    return AuthService;
}());
export { AuthService };
export function AuthFactory(service) {
    return function () { return service.load(); };
}
